import { render, staticRenderFns } from "./highscore.vue?vue&type=template&id=ad022d00&scoped=true&"
import script from "./highscore.vue?vue&type=script&lang=js&"
export * from "./highscore.vue?vue&type=script&lang=js&"
import style0 from "./highscore.vue?vue&type=style&index=0&id=ad022d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad022d00",
  null
  
)

export default component.exports